<div class="dmz-public-layout">
  <div class="loader-content" *ngIf="isLoading">
    <div class="spinner">
      <mat-spinner [diameter]="60"></mat-spinner>
    </div>
    <div class="loader-text">
      <div class="text-message">{{ loaderMessage }}</div>
    </div>
  </div>
  <div class="container" *ngIf="!isLoading">
    <div class="header-title">
      <div>
        <span class="title">{{ title }}</span>
      </div>
    </div>
    <div class="container-body">
      <div class="inner-body">
        <label
          ><i class="icon mdi mdi-web-box ng-star-inserted"></i>
          <span class="label"><b>Public web access</b></span></label
        >
        <div class="label">
          <div class="web-access">
            Define a public facing hostname that can be used by TrueSpeed test clients
          </div>
        </div>
        <form name="webAccess" #webAccess="ngForm">
          <div class="form-inputs">
            <div class="host-name">
              <span class="label"><b>Hostname or IP address</b></span>
              <input
                matInput
                autocomplete="off"
                class="width100"
                type="text"
                [(ngModel)]="formData.hostName"
                name="hostName"
                [disabled]="!isUserManageSystem"
                #hostNameInput="ngModel"
                [pattern]="hostNameAndIPRegEx"
                (ngModelChange)="onChangeHostnameOrIPaddress()"
                required
              />
            </div>
            <div class="port">
              <div class="label"><b>Port</b></div>
              <input
                matInput
                autocomplete="off"
                class="width30"
                type="number"
                [(ngModel)]="formData.port"
                name="port"
                [disabled]="!isUserManageSystem"
                #portInput="ngModel"
                max="65535"
                min="0"
              />
              <div
                class="error"
                *ngIf="portInput.invalid && (portInput.dirty || portInput.touched)"
              >
                <mat-error *ngIf="portInput.errors.max">Enter a valid port (0-65535)</mat-error>
              </div>
            </div>
          </div>
          <div
            class="error"
            *ngIf="hostNameInput.invalid && (hostNameInput.dirty || hostNameInput.touched)"
          >
            <mat-error *ngIf="hostNameInput?.errors?.required">
              Hostname or IP address required</mat-error
            >
            <mat-error *ngIf="hostNameInput.errors?.pattern"
              >Invalid hostname or IP address</mat-error
            >
          </div>
        </form>
      </div>

      <div class="btn-align">
        <button
          mat-flat-button
          [disabled]="portInput.invalid || !isUserManageSystem || !isValidHostnameOrIPaddress"
          (click)="saveConfig()"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</div>
